import { z } from 'zod';
export const StakeholderResidencySchema = z.object({
    country: z.string().nullish(),
    state: z.string().nullish(),
    address: z.string().nullish()
});
export const StakeholderSchema = z.object({
    firstName: z.string().nullish(),
    middleName: z.string().nullish(),
    lastName: z.string().nullish(),
    name: z.string().nullish(),
    role: z.string().nullish(),
    title: z.string().nullish(),
    nationality: z.string().nullish(),
    dateOfBirth: z.string().nullish(),
    cityOfBirth: z.string().nullish(),
    countryOfBirth: z.string().nullish(),
    residency: StakeholderResidencySchema.nullish()
});
export const CompanyRegistryCheckInputSchema = z.object({
    enabled: z.boolean(),
    registrationNumber: z.string().nullish(),
    country: z.string().nullish(),
    state: z.string().nullish()
});
export const GatedContentCheckInputSchema = z.object({
    enabled: z.boolean(),
    username: z.string().nullish(),
    password: z.string().nullish()
});
export const TransactionAnalysisInputSchema = z.object({
    enabled: z.boolean(),
    fileUrl: z.string().nullish()
});
export const MsaFileAnalysisInputSchema = z.object({
    persistedFileId: z.string().nullish(),
    msaFileUrl: z.string().nullish()
});
export const BaseReportInputSchema = z.object({
    // Identity
    companyName: z.string().nullish(),
    countryCode: z.string().length(2).nullish(),
    registrationNumber: z.string().nullish(),
    websiteUrl: z.string().url().nullish(),
    merchantId: z.string().nullish(),
    // Contact (arrays)
    addresses: z.array(z.string()).nullish(),
    emails: z.array(z.string()).nullish(),
    phoneNumbers: z.array(z.string()).nullish(),
    urls: z.array(z.string()).nullish(),
    // Contact (legacy singular — kept for backward compat with migrated data)
    address: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    email: z.string().nullish(),
    additionalUrls: z.array(z.string()).nullish(),
    // Business details
    mcc: z.string().nullish(),
    dba: z.array(z.string()).nullish(),
    lineOfBusiness: z.string().nullish(),
    billingDescriptors: z.array(z.string()).nullish(),
    icaBin: z.string().nullish(),
    icaBinName: z.string().nullish(),
    additionalInformation: z.string().nullish(),
    parentCompanyName: z.string().nullish(),
    state: z.string().nullish(),
    // Entities
    stakeholders: z.array(StakeholderSchema).nullish(),
    // Feature configs (optional)
    companyRegistryCheck: CompanyRegistryCheckInputSchema.nullish(),
    gatedContentCheck: GatedContentCheckInputSchema.nullish(),
    transactionAnalysis: TransactionAnalysisInputSchema.nullish(),
    msaFileAnalysis: MsaFileAnalysisInputSchema.nullish(),
    // Settings
    isOngoingMonitoringEnabled: z.boolean().nullish(),
    // Canonical snake_case dialect (matches report_series.schedule's pgEnum and
    // MonitoringScheduleType). The previous kebab-case enum here never matched
    // stored data — prod was verified snake-only (BAL-7106), so no backfill needed.
    monitoringFrequency: z.enum([
        'weekly',
        'monthly',
        'twice_monthly',
        'every_two_months',
        'custom',
        'inactive'
    ]).nullish()
}).meta({
    id: 'BaseReportInput'
});

//# sourceMappingURL=inputs.schema.js.map